"use client";

import { useEffect, useState } from "react";
import classNames from "classnames";
import { AccordionTabContent } from "./AccordionTabContent";
import { CardBox } from "../CardBox";
import { Tab } from "./Tab";
import { TabsProps } from "./types";
import { useAccordion } from "@/hooks/useAccordion";

import "./styles.scss";

export const Tabs = ({ tabsData, light, className }: TabsProps) => {
  const [currentTab, setCurrentTab] = useState("1");
  const { activeItem, toggleOpen, setActiveItem } = useAccordion();

  const classnames = classNames(`Tabs`, {
    ["Tabs--light"]: light,
    [`${className}`]: className,
  });

  useEffect(() => {
    setActiveItem(0);
  }, [currentTab]);

  const handleTabClick = (id: string) => setCurrentTab(id);

  return (
    <div className={classnames} data-testid="Tabs">
      <ul className="nav">
        {tabsData.map((tab, i) => (
          <Tab
            tab={tab}
            key={i}
            handleTabClick={handleTabClick}
            currentTab={currentTab}
          />
        ))}
      </ul>
      <div className="content">
        {tabsData?.map((tab, i) => (
          <div key={i}>
            {currentTab === `${tab.id}` && (
              <div>
                {tab?.type === "accordion" ? (
                  <>
                    {Array.isArray(tab.content) &&
                      tab.content.map((item, i) => (
                        <AccordionTabContent
                          key={i}
                          item={item}
                          index={i}
                          activeItem={activeItem}
                          toggle={toggleOpen}
                        />
                      ))}
                  </>
                ) : (
                  <>
                    {!Array.isArray(tab.content) ? (
                      <p>{tab.content}</p>
                    ) : (
                      <div>
                        {Array.isArray(tab.content) &&
                          tab.content.map((item, i) => (
                            <CardBox item={item} key={i} />
                          ))}
                      </div>
                    )}
                  </>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
